export const CINEMAS_VISIBLE = 'CINEMAS_VISIBLE';
export const CINEMAS_LOADING = 'CINEMAS_LOADING';
export const CINEMAS_PASSWORD = 'CINEMAS_PASSWORD';
export const CINEMAS_CONFIRM_PASSWORD = 'CINEMAS_CONFIRM_PASSWORD';
export const CINEMAS_ERROR = 'CINEMAS_ERROR';
